import { createContext } from "react";
import { reviewersInitialState } from "./reviewersInitialState";


const ReviewersContext = createContext(reviewersInitialState)

export default ReviewersContext